import { lazyRouteComponent } from '@tanstack/react-router';

import { Route } from '@lib/types/route';
import { routePathMatches } from '@lib/utils/route';

import { ROUTE_PATHS } from '../route-paths';

const ForgotPasswordPage = lazyRouteComponent(
  () => import('./pages/forgot-password'),
);

const LoginPage = lazyRouteComponent(() => import('./pages/login'));

const RegisterPage = lazyRouteComponent(() => import('./pages/register'));

const ServiceUnavailablePage = lazyRouteComponent(
  () => import('./pages/service-unavailable'),
);

export const isAuthenticationRoute = (path: string) =>
  routePathMatches(path, ROUTE_PATHS.LOGIN) ||
  routePathMatches(path, ROUTE_PATHS.REGISTER) ||
  routePathMatches(path, ROUTE_PATHS.FORGOT_PASSWORD);

export const getRoutes = (): Route[] => [
  {
    title: 'Criar conta',
    path: ROUTE_PATHS.REGISTER,
    page: RegisterPage,
    hidden: true,
    public: true,
  },
  {
    title: 'Entrar',
    path: ROUTE_PATHS.LOGIN,
    page: LoginPage,
    hidden: true,
    public: true,
  },
  {
    title: 'Recuperar senha',
    path: ROUTE_PATHS.FORGOT_PASSWORD,
    page: ForgotPasswordPage,
    hidden: true,
    public: true,
  },
  {
    title: 'Serviço indisponível',
    path: ROUTE_PATHS.SERVICE_UNAVAILABLE,
    page: ServiceUnavailablePage,
    hidden: true,
    public: true,
  },
];
